import Link from "next/link"
import { useRouter } from "next/router"
import React from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"
import { selectAuthorization } from "~/slices/authorizationSlice"
import AcIcon from "../atoms/AcIcon"

const GlobalFooter = styled.footer`
  &.site-footer {
    display: flex;
    justify-content: space-around;
    width: 100%;
    padding: 32px 20px;
    background-color: #f6f9fc;
    border-top: 1px solid #d8dbe2;
  }

  .site-copy {
    color: #8d96a9;
    text-align: center;
  }

  .link {
    display: flex;
  }
  .abs-link {
    margin-left: 30px;
  }

  i {
    svg {
      path {
        fill: #6b6bf9;
      }
    }
  }

  @media screen and (max-width: 460px) {
    flex-direction: column;
    align-items: center;
    .link {
      margin-bottom: 10px;
    }

    .site-footer {
      position: absolute;
      bottom: -55px;
      width: 100%;
      padding: 32px 20px;
      background-color: #f6f9fc;
      border-top: 1px solid #d8dbe2;
    }
  }
`

export default function Footer() {
  const user = useSelector(selectAuthorization).user
  const router = useRouter()

  const isAuthenUrl =
    router.pathname.split("/")?.includes("authentication") ||
    router.pathname.split("/")?.includes("term")
  return (
    <GlobalFooter className={"site-footer"}>
      {(user || isAuthenUrl) && (
        <div className="link">
          <Link href="/term">利用規約</Link>
          <a href="https://am-bition.jp/privacy/" className="abs-link">
            個人情報保護方針
          </a>
          <AcIcon name="fa-arrow-up-right-from-square" />
        </div>
      )}
      <p className={"site-copy"}>
        <small>Copyright&copy;AMBITION All Rights Reserved.</small>
      </p>
    </GlobalFooter>
  )
}
